import styled, { css } from 'styled-components';

const primaryCSS = css`
  background: ${({ theme }) => theme.colors.gradient};
  color: ${({ theme }) => theme.colors.btnWhite};
  &:hover {
    background: ${({ theme }) => theme.colors.hoverGradient};
  }
`;

const secondaryCSS = css`
  color: ${({ theme }) => theme.colors.gradient};
  background: ${({ theme }) => theme.colors.gradient};
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  border: 1px solid ${({ theme }) => theme.colors.gp2};
  padding: calc(0.5rem - 1px) 2rem;

  &:hover {
    background: ${({ theme }) => theme.colors.hoverGradient};
    color: ${({ theme }) => theme.colors.white};
    background-clip: inherit;
    -webkit-background-clip: inherit;
    -webkit-text-fill-color: ${({ theme }) => theme.colors.btnWhite};
  }

  @supports not (-webkit-background-clip: text) {
    background-clip: none;
  }
`;

const disabledCSS = css`
  color: ${({ theme }) => theme.colors.white};
  background: ${({ theme }) => theme.colors.cflowerBlue};
  cursor: not-allowed;
`;
const disabledSecondaryCSS = css`
  color: ${({ theme }) => theme.colors.cflowerBlue};
  background: transparent;
  background-clip: inherit;
  -webkit-text-fill-color: ${({ theme }) => theme.colors.cflowerBlue};
  border: 1px solid ${({ theme }) => theme.colors.cflowerBlue};
  -webkit-background-clip: inherit;
  cursor: not-allowed;
`;

interface ButtonProps {
  primary?: boolean;
  secondary?: boolean;
  $constWidth?: number;
  $small?: boolean;
}

const Button = styled.button.attrs<{ primary?: boolean; secondary?: boolean }>((props) => ({
  type: 'button',
  ...props,
}))<ButtonProps>`
  font-family: Poppins, sans-serif;
  display: inline-block;
  appearance: none;
  border: none;
  padding: 1px 1.8rem;
  outline: none;
  cursor: pointer;
  white-space: nowrap;
  margin: 0;
  text-decoration: none;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  text-transform: uppercase;
  height: 52px;
  min-width: 150px;
  ${({ primary }) => primary && primaryCSS};
  ${({ secondary }) => secondary && secondaryCSS};
  &:disabled {
    ${({ secondary }) => (secondary ? disabledSecondaryCSS : disabledCSS)};
  }
  border-radius: 3px;

  ${({ $small }) =>
    $small &&
    css`
      height: 36px;
      min-width: 100px;
      padding: 1px 1.2rem;
      font-size: 13px;
      line-height: 20px;
    `}

  ${({ $constWidth }) =>
    $constWidth &&
    css`
      width: ${$constWidth}px;
      ${({ theme }) => theme.breakpoints.down('md')} {
        width: ${$constWidth * 0.8}px;
      }
      ${({ theme }) => theme.breakpoints.down('sm')} {
        width: ${$constWidth * 0.6}px;
      }
    `}
  ${({ theme }) => theme.breakpoints.down('md')} {
    height: 40px;
    min-width: 120px;
    padding: 1px 1.3rem;
    font-size: 12px;
    svg {
      transform: scale(0.8);
    }
  }
  ${({ theme }) => theme.breakpoints.down('sm')} {
    height: 34px;
    min-width: 100px;
    padding: 1px 0.8rem;
    font-size: 10px;
    svg {
      transform: scale(0.6);
    }
  }
`;

export default Button;
